import React, {useState} from "react"

import {Wallet} from "@irati/types"
import Slider from "@irati/ui/src/Slider"
import {DESKTOP, LARGE_DESKTOP, PHONE, PHONE_LANDSCAPE, TABLET} from "@irati/ui/src/global/media"
import {RouterLink} from "@irati/ui/src/Link"

import Spacing from "@irati/ui/src/Spacing"
import CardRoutes from "../../enums/CardRoutes"
import TreatTokenWallet from "./TreatTokenWallet"
import RewardWallet from "./RewardWallet"
import {WalletPointsCard} from "./styled"
import CustomRewards from "./CustomRewards"
import CashbackWallet from "./CashbackWallet"
import {FamilyFriendsPopup} from "../FamilyFriendsPopup"

interface Props {
  wallet?: Wallet
  tokenWallet?: Wallet
  rewardWallet?: Wallet
  hasCustomReward?: boolean
  cashbackWallet?: Wallet
}

/** slider options dict where key is the number of wallet cards */
const sliderSettings: Record<number, any> = {
  1: [{breakpoint: PHONE, settings: {slidesToShow: 1}}],
  2: [
    {breakpoint: PHONE_LANDSCAPE - 1, settings: {slidesToShow: 1.2, slidesToScroll: 1}},
    {breakpoint: TABLET - 1, settings: {slidesToShow: 2, slidesToScroll: 2}}
  ],
  3: [
    {breakpoint: PHONE_LANDSCAPE - 1, settings: {slidesToShow: 1.2, slidesToScroll: 1}},
    {breakpoint: TABLET - 1, settings: {slidesToShow: 1.2, slidesToScroll: 1}},
    {breakpoint: DESKTOP - 1, settings: {slidesToShow: 2, slidesToScroll: 1}},
    {breakpoint: LARGE_DESKTOP - 1, settings: {slidesToShow: 3, slidesToScroll: 1.5}}
  ],
  4: [
    {breakpoint: PHONE_LANDSCAPE - 1, settings: {slidesToShow: 1.2, slidesToScroll: 1}},
    {breakpoint: TABLET - 1, settings: {slidesToShow: 1.2, slidesToScroll: 1}},
    {breakpoint: DESKTOP - 1, settings: {slidesToShow: 2, slidesToScroll: 2}},
    {breakpoint: LARGE_DESKTOP - 1, settings: {slidesToShow: 2.5, slidesToScroll: 1.5}}
  ]
}

const WalletBalanceCard: React.FC<Props> = ({tokenWallet, rewardWallet, hasCustomReward, cashbackWallet}) => {
  const pathName = window.location.pathname.split("/").pop()
  const [showInvitationPopup, setShowInvitationPopup] = useState(false)
  const slideCount = [hasCustomReward, tokenWallet, rewardWallet, cashbackWallet].filter(Boolean).length

  return (
    <Spacing marginTop={5} marginBottom={1}>
      <Slider slidesToShow={slideCount} settings={{responsive: sliderSettings[slideCount]}} maintainSameHeight gap={2}>
        {hasCustomReward && (
          <WalletPointsCard>
            <RouterLink to="/custom-rewards" plain>
              <CustomRewards active={pathName === CardRoutes.CustomRewards} />
            </RouterLink>
          </WalletPointsCard>
        )}
        {tokenWallet && (
          <WalletPointsCard>
            <RouterLink to="/flexi-points" plain>
              <TreatTokenWallet wallet={tokenWallet} active={pathName === CardRoutes.FlexiPoints} />
            </RouterLink>
          </WalletPointsCard>
        )}
        {rewardWallet && (
          <WalletPointsCard id="rewardPointsWalletCard">
            <RouterLink to="/reward-points" plain>
              <RewardWallet
                wallet={rewardWallet}
                active={pathName === CardRoutes.RewardPoints}
                showInvitationPopup={() => setShowInvitationPopup(true)}
              />
            </RouterLink>
          </WalletPointsCard>
        )}
        {cashbackWallet && (
          <WalletPointsCard id="cashbackWalletCard">
            <RouterLink to="/cashback" plain>
              <CashbackWallet wallet={cashbackWallet!} active={pathName === CardRoutes.Cashback} />
            </RouterLink>
          </WalletPointsCard>
        )}
      </Slider>
      <FamilyFriendsPopup showPopup={showInvitationPopup} onHide={() => setShowInvitationPopup(false)} />
    </Spacing>
  )
}

export default WalletBalanceCard
